import { Box, Button } from "@mui/material";
import Alert from "components/alert";
import NotAuthorized from "components/notAuthorized";
import useApi from "hooks/useApi";
import useApiCall from "hooks/useApiCall";
import useNotificationQuery from "hooks/useNotificationQuery";
import usePermissions from "hooks/usePermissions";
import { setLoading } from "lib/Reducer/loadingSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { restoreInvoice, viewAllInvoice } from "../api/invoices";
import BulkActions from "./BulkActions";
import Header from "./Header";
import AdvanceFilter from "./filter/AdvanceFilter";
import MainScreenFilter from "./filter/MainScreenFilter";
import MainTable from "./table/MainTable";
import useBase from "hooks/useBase";

const InvoicesTrash = () => {
  const [activeMenu, setActiveMenu] = useState("");
  const [openSidebar, setOpenSidebar] = useState(false);
  const [openFilter, setOpenFilter] = useState(false);
  const [allInvoices, setAllInvoices] = useState([]);
  // Helper states
  const { updateBase, base } = useBase();
  const [reload, setReload] = useState(false);
  const [filters, setFilters] = useState({});
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({
    current_page: 1,
    per_page: 10,
  });

  const isFiltering = () => {
    let filtering = false;
    for (const key in filters) {
      if (Array.isArray(filters[key])) {
        if (filters[key].length > 0) filtering = true;
      } else {
        if (filters[key]) filtering = true;
      }
    }
    return filtering;
  };

  const { data, loading, fetchData: fetchListData } = useApiCall();

  useEffect(() => {
    updateBase(["customers", "assignees", "intakes"]);
  }, [reload]);

  let getParamsId = useNotificationQuery(reload);
  useEffect(() => {
    let finalFilters = { ...filters };
    let finalPagination = { ...pagination };
    finalFilters.search = search;
    finalFilters.id = getParamsId;
    fetchListData(
      viewAllInvoice,
      {
        body_data: finalFilters,
        params: `page=${finalPagination?.current_page}&limit=${finalPagination?.per_page}`,
      },
      false
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    reload,
    search,
    pagination?.current_page,
    pagination?.per_page,
    getParamsId,
  ]);

  useEffect(() => {
    if (data) {
      const { data: allData, ...rest } = data;
      setAllInvoices(allData);
      setPagination(rest);
      setSelectedRows([]);
    }
  }, [data]);

  const [openAlert, setOpenAlert] = useState(false);

  const handleDelete = async (id) => {
    setOpenAlert(id);
  };
  const { fetchData: deleteApi } = useApi();

  const handleDeleteConfirm = async () => {
    setOpenAlert(false);
    setSelectedRows([]);
    const endpoint = {
      method: "delete",
      url: `/api/admin/invoice/delete/${openAlert}`,
    };
    const result = await deleteApi(endpoint);
    if (result.success) {
      if (allInvoices?.length > 1) {
        setAllInvoices(
          allInvoices.filter((customer) => customer?.id !== openAlert)
        );
      } else {
        setReload((pre) => !pre);
      }
    }
  };

  const permissions = usePermissions("invoice");

  const all_props = {
    ...base,
    setReload,
    filters,
    setFilters,
    isFiltering,
    pagination,
    setPagination,
    allInvoices,
    setAllInvoices,
    permissions,
  };

  // Bulk options
  const [selectedRows, setSelectedRows] = useState([]);

  const handleTableCheckBox = (id, checked) => {
    if (id === "all") {
      if (checked) {
        setSelectedRows(allInvoices?.map((customer) => customer?.id));
      } else {
        setSelectedRows([]);
      }
    } else {
      if (checked) {
        setSelectedRows([...selectedRows, id]);
      } else {
        setSelectedRows(selectedRows?.filter((customer) => customer !== id));
      }
    }
  };
  const dispatch = useDispatch();

  const handleRestore = async (id) => {
    dispatch(setLoading(true));
    try {
      const result = await restoreInvoice({ id });
      if (result.success) {
        toast.success(result?.message);
      } else {
        toast.error(result?.message);
      }
      setReload((pre) => !pre);
      dispatch(setLoading(false));
    } catch (error) {
      dispatch(setLoading(false));
    }
  };

  return (
    <div>
      {openAlert && (
        <Alert
          open={openAlert}
          handleClose={setOpenAlert}
          title="Delete Invoice"
          desc={
            <Box>
              Are you sure you want to delete? This will delete this invoice
              permanently. <strong>You can't undo this action</strong>
            </Box>
          }
          buttons={
            <>
              <Button onClick={() => setOpenAlert(false)}>No, keep it</Button>
              <Button variant="solid" onClick={handleDeleteConfirm}>
                Yes, delete it
              </Button>
            </>
          }
        />
      )}
      <Header
        {...{
          activeMenu,
          setActiveMenu,
          openSidebar,
          setOpenSidebar,
          setOpenFilter,
          setSearch,
          isFiltering,
          setPagination,
          pagination,
          permissions,
          allInvoices,
          setReload,
          search,
          filters,
        }}
      />
      {openFilter && (
        <AdvanceFilter
          openDrawer={openFilter}
          setOpenDrawer={setOpenFilter}
          {...all_props}
        />
      )}
      {!activeMenu &&
        !selectedRows?.length > 0 &&
        !!(
          permissions["trash list(own)"] || permissions["trash list(global)"]
        ) && <MainScreenFilter {...all_props} />}
      {selectedRows?.length > 0 && (
        <BulkActions
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          {...all_props}
        />
      )}
      {!activeMenu &&
        (permissions["trash list(own)"] || permissions["trash list(global)"] ? (
          <MainTable
            handleDelete={handleDelete}
            loading={loading}
            handleTableCheckBox={handleTableCheckBox}
            selectedRows={selectedRows}
            handleRestore={handleRestore}
            {...all_props}
          />
        ) : (
          <NotAuthorized />
        ))}
    </div>
  );
};

export default InvoicesTrash;
